import React from 'react';

const CancelIcon = ({ color = 'white' }) => (
  <div>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9497 10.9498C10.5214 11.3782 9.8075 11.3782 9.40295 10.9736L5.9762 7.54688L2.54946 10.9736C2.14491 11.3782 1.4548 11.3544 1.05025 10.9498C0.621909 10.5215 0.621909 9.85517 1.02646 9.45063L4.4532 6.02388L1.02646 2.59713C0.598112 2.16879 0.621909 1.47868 1.05025 1.05033C1.4548 0.645787 2.12111 0.645787 2.54945 1.07413L5.9762 4.50088L9.40295 1.07413C9.83129 0.645787 10.5214 0.62199 10.9497 1.05033C11.3543 1.45488 11.3543 2.16879 10.926 2.59713L7.4992 6.02388L10.926 9.45063C11.3543 9.83138 11.3543 10.5453 10.9497 10.9498Z"
        fill={color}
      />
    </svg>
  </div>
);

export default CancelIcon;
